import { useStore } from '@/relatos/store';
import { npubOf } from '@/relatos/client';

export function shortNpub(pk: string): string {
  const n = npubOf(pk);
  return n.slice(0, 12) + '…' + n.slice(-4);
}

export function displayName(pk: string, profiles: Record<string, { name?: string }>): string {
  return profiles[pk]?.name || shortNpub(pk);
}

export function Avatar({ pk, size = 72 }: { pk: string; size?: number }) {
  const { profiles } = useStore();
  const p = profiles[pk];
  const style = { width: size, height: size, fontSize: size * 0.36 };
  return (
    <span className="rl-avatar" style={style} aria-hidden>
      {p?.picture
        ? <img src={p.picture} alt="" loading="lazy" onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }} />
        : displayName(pk, profiles).slice(0, 2).toUpperCase()}
    </span>
  );
}

export function Author({ pk }: { pk: string }) {
  const { profiles } = useStore();
  const name = profiles[pk]?.name;
  return (
    <div>
      <div className="rl-author">{name ?? shortNpub(pk)}</div>
      {name && <div className="rl-npub">{shortNpub(pk)}</div>}
    </div>
  );
}

export function TimeAgo({ ts }: { ts: number }) {
  const d = new Date(ts * 1000);
  const diff = Date.now() / 1000 - ts;
  const abs = d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
  let rel: string;
  if (diff < 60) rel = 'just now';
  else if (diff < 3600) rel = `${Math.floor(diff / 60)} min ago`;
  else if (diff < 86400) rel = `${Math.floor(diff / 3600)} h ago`;
  else rel = `${Math.floor(diff / 86400)} d ago`;
  return <span title={abs}>{abs} <span className="rl-small">({rel})</span></span>;
}

export function OnlinePill({ online }: { online: Record<string, number> }) {
  const now = Date.now() / 1000;
  const count = Object.values(online).filter(ts => now - ts < 180).length;
  return (
    <span className="rl-pill">
      <span className="rl-online-dot" aria-hidden />
      {count} online
    </span>
  );
}
